<template>
	<canvas ref="chartRef"></canvas>
</template>

<script>
import { defineComponent, onMounted, ref, inject, watch } from "vue";
import { helper as $h }			from "@/utils/helper";
import isEqual 					from "lodash.isequal";

import { Chart, registerables } from "chart.js";

Chart.register(...registerables);

export default defineComponent({
	props: {
		type: {
			type: String,
			default: "doughnut",
			validator: value => ["line", "pie", "doughnut", "bar"].includes(value)
		},
		data: {
			type: Object,
			required: true,
			default: () => ({})
		},
		options: {
			type: Object,
			default: () => ({
				responsive: true,
				maintainAspectRatio: true,
				cutout: '70%',
				plugins: {
					legend: { display: false }
				}
			})
		},
		height: {
			type: Number,
			default: 190
		},
		refKey: {
			type: String,
			default: null
		}
	},


	setup(props) {
		const chartRef = ref(null);
		const chartInstance = ref(null);
		const dataDivision = ref([]);

		const setSize = () => {
			const canvas = chartRef.value;
			if (!canvas) return;

			if (props.width) {
				canvas.width = props.width;
				canvas.style.width = `${props.width}px`;
			}

			if (props.height) {
				canvas.height = props.height;
				canvas.style.height = `${props.height}px`;
			}
		};

		const bindInstance = () => {
			if (props.refKey) {
				const bind = inject(`bind[${props.refKey}]`);
				if (bind) {
					bind(chartRef.value);
				}
			}
		};

		const createChart = () => {
			const ctx = chartRef.value.getContext("2d");
			chartInstance.value = new Chart(ctx, {
				type: props.type,
				data: $h.toRaw(props.data),
				options: props.options
			});
			chartRef.value.instance = chartInstance.value;
			dataDivision.value = [...$h.toRaw(props.data).datasets[0]?.data || []];
		};

		const recreateChart = () => {
			// Elimina la instancia anterior si existe
			if (chartInstance.value) {
				chartInstance.value.destroy();
			}

			const ctx = chartRef.value.getContext("2d");
			chartInstance.value = new Chart(ctx, {
				type: props.type,
				data: $h.toRaw(props.data),
				options: props.options
			});
			chartRef.value.instance = chartInstance.value;

			// Guarda la data actual para comparación futura
			dataDivision.value = [...$h.toRaw(props.data).datasets[0]?.data || []];
		};

		const updateChart = () => {
			if (!chartInstance.value) {
				return;
			}
			
			const rawData = $h.toRaw(props.data);
			const newData = rawData.datasets[0]?.data || [];

			if (isEqual(newData, dataDivision.value)) return;

			recreateChart();
		}

		onMounted(() => {
			bindInstance();
			setSize();
			createChart();
		});

		watch(
			() => [props.data, props.options],
			() => updateChart(),
			{ deep: true }
		);

		return {
			chartRef
		};
	}
});
</script>